import { Fancybox } from "@fancyapps/ui";

window.Fancybox = Fancybox;

const _returningToFirst = new WeakSet();

Fancybox.bind("[data-gallery]", {
    groupAttr: "data-gallery",
    groupAll: false,
    dragToClose: true,
    showClass: "f-fadeIn",
    hideClass: "f-fadeOut",
    Carousel: {
        transition: "slide",
        infinite: true,
        Thumbs: false,
        Toolbar: {
            items: {
                close: {
                    tpl: `<button class="f-button f-close" title="Close" aria-label="Close" data-fancybox-close>
                  <svg viewBox="0 0 21.135 21.135" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.061 1.061l19.014 19.014m-19.014 0L20.075 1.061" fill="none" stroke="currentColor" stroke-width="3"></path>
                  </svg>
                </button>`,
                },
            },
            display: {
                left: [],
                middle: ["prev", "next"],
                right: ["close"],
            },
        },

        Arrows: {
            prevTpl: `<svg class="sw-only" viewBox="0 0 30 16.863" xmlns="http://www.w3.org/2000/svg">
                  <path fill="currentColor" d="M21.569 0L19.8 1.8l5.372 5.372H0v2.51h25.176L19.8 15.059l1.765 1.8L30 8.431z"></path>
                </svg>
                <svg class="fh-only" xmlns="http://www.w3.org/2000/svg" width="30" height="30">
                    <path fill="none" stroke="currentColor" stroke-width="2" d="M13.33 17.525L22 9.224 13.33.922M22 9.224H0"></path>
                </svg>`,
            nextTpl: `<svg class="sw-only" viewBox="0 0 30 16.863" xmlns="http://www.w3.org/2000/svg">
                  <path fill="currentColor" d="M21.569 0L19.8 1.8l5.372 5.372H0v2.51h25.176L19.8 15.059l1.765 1.8L30 8.431z"></path>
                </svg>
                <svg class="fh-only" xmlns="http://www.w3.org/2000/svg" width="30" height="30">
                    <path fill="none" stroke="currentColor" stroke-width="2" d="M13.33 17.525L22 9.224 13.33.922M22 9.224H0"></path>
                </svg>`,
        },

        Video: {
            autoplay: true,
        },
    },
    on: {
        "Carousel.ready": (fb, carousel) => {
            dispatchEvent(new Event('lightbox:open'));
            const c = carousel || fb.getCarousel();

            const count = c?.getSlides()?.length ?? 0;
            const single = count <= 1;

            const $prev = fb.getContainer()?.querySelector(".is-prev");
            const $next = fb.getContainer()?.querySelector(".is-next");
            if ($prev) $prev.style.display = single ? "none" : "";
            if ($next) $next.style.display = single ? "none" : "";
        },

        init: (fb) => {
            const origin = fb.getOrigin?.();
            const root = origin?.closest?.(".splide") || document;
            root.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true }));
        },

        close: (fb) => {
            const origin = fb.getOrigin?.();
            const root = origin?.closest?.(".splide") || document;
            root.dispatchEvent(new CustomEvent("lightbox:close", { bubbles: true }));
        },

        "Carousel.change": () => {
            window.lazyLoadInstance?.update?.();
        },

        shouldClose: (fb, evt) => {
            const carousel = fb.getCarousel?.();
            const container = fb.getContainer?.();
            if (!carousel || !container) return;

            if (carousel.getPageIndex() === 0 || _returningToFirst.has(fb)) {
                _returningToFirst.delete(fb);
                return;
            }

            evt?.preventDefault();
            _returningToFirst.add(fb);

            container.style.visibility = "hidden";
            container.style.opacity = "0";
            container.style.pointerEvents = "none";

            const finish = () => {
                carousel.off("settle", finish);
                _returningToFirst.delete(fb);
                fb.close();
            };

            const watchdog = setTimeout(() => {
                finish();
            }, 1000);

            carousel.on("settle", () => {
                clearTimeout(watchdog);
                finish();
            });

            carousel.goTo(0, { friction: 0 });
        },

        destroy: (fb) => {
            _returningToFirst.delete(fb);
        },
    }
});
